<template>
    <div>
        <main class="main-content">
            <div class="page-content">
                <div class="container-xl">
                    <section class="section-hotels-edit-rooms">
                        <div class="hotels-wrap">
                          <HotelsSideMenu />
                            <div class="hotels-content">
                                <div class="lds-ring" v-if="!isLoad">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                                <div class="seasons-edit" v-if="isLoad">
                                    <h1 class="hotel-inner__title">{{ hotelName }}</h1>
                                    <div class="page-title-2">
                                        <h2>Seasons</h2>
                                    </div>
                                    <form>
                                        <div class="seasons-selects">
                                            <span class="form-control-label">Names of Seasons</span>
                                            <div class="form-control-group form-control-group_seasons"
                                                 v-for="(item, index) in seasons"
                                                 :key="index">
                                                <span class="form-control-group_seasons-count">{{ index + 1 }}</span>
                                                <div :class="['form-control-wrap', { 'is-error' : item.error }]"
                                                     :style="{width: '24rem'}">
                                                    <input type="text" class="form-control" v-model="item.name"
                                                           @focus="item.error = false"
                                                           @change="isEdit = true"
                                                           :style="{paddingLeft: '4rem', paddingRight: '1rem'}">
                                                </div>
                                                <button type="button" class="btn btn--remove" @click="$emit('deleteModalHandler', {
                                    entity: 'Season',
                                    name: 'this',
                                    handler: removeSeason,
                                    id: index
                                })">
                                                    <svg width="1em" height="1em" class="icon icon-close ">
                                                        <use
                                                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                                    </svg>
                                                </button>
                                            </div>

                                            <div class="edit-seasons__btns">
                                                <button type="button" class="btn btn--rounded2 btn--green"
                                                        @click="addSeason">
                                                    <span>Add Season</span></button>
                                                <button type="button" class="btn btn--rounded2 btn--green"
                                                        @click="updateSeasons()">
                                                    <svg width="1em" height="1em" class="icon icon-recalc">
                                                        <use
                                                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-recalc"></use>
                                                    </svg>
                                                    <span>Update</span>
                                                </button>
                                            </div>
                                        </div>

                                        <div class="hotels-items" v-for="(item, index) in years" :key="index">
                                            <div class="hotels-items__top">
                                                <div class="form-control-group">
                                                    <span class="form-control-label">Year</span>
                                                    <div class="form-control-wrap">
                                                        <div
                                                            :class="['select-wrapper', {'is-active': item.yearSelect}, { 'is-error' : item.error }]"
                                                            @click="item.error = false;years = years.map((year, yearIndex) => ({...year, yearSelect: yearIndex === index ? !year.yearSelect : false ,dates: year.dates.map((dateItem, dateIndex) => ({...dateItem, select:  false}))}))">
                                                            <div class="select-trigger">
                                                                <span class="select-trigger__name">{{
                                                                        item.year
                                                                    }}</span>
                                                                <span class="select-trigger__icon">
                                    <svg width="1em" height="1em" class="icon icon-chevron ">
                                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                    </svg>
                                  </span>
                                                            </div>
                                                            <div class="select-body">
                                                                <div class="select-inner js-scrollbar">
                                                                    <div
                                                                        v-for="(year, index) in data.years.filter(y => !years.map(yd => yd.year).includes(y))"
                                                                        :key="index"
                                                                        :class="['select-option', { 'is-selected' : year === item.year }]"
                                                                        @click="item.year = year;isEdit = true; changeYear(item)"><span
                                                                        class="select-option__name">{{ year }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="btn_copy-price">
                                                    <button type="button" :disabled="!item.year"
                                                            data-popover="Copy rates from the previous year"
                                                            @click="copy = item.year"
                                                            class="btn btn--green btn--sm-squared btn--popover">
                                                        <svg width="1em" height="1em" class="icon icon-copy ">
                                                            <use
                                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="hotels-body">
                                                <div class="hotels-seasons-item" v-for="(date, i) in item.dates"
                                                     :key="i">
                                                    <div
                                                        class="form-control-datepicker form-control-datepicker--labeled">
                                                        <div class="form-control-group">
                                                            <span class="form-control-label">From</span>
                                                            <div
                                                                :class="['form-control-wrap', { 'is-error' : date.errors.from }]">
                                                                <input type="text" Placeholder="Date From"
                                                                       :value="date.from"
                                                                       @focus="date.errors.from = false"
                                                                       @blur="date.from = $event.target.value;isEdit = true"
                                                                       class="form-control js-datepicker-single">
                                                                <div class="form-control-icon">
                                                                    <svg width="1em" height="1em"
                                                                         class="icon icon-calendar ">
                                                                        <use
                                                                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="form-control-group">
                                                            <span class="form-control-label">To</span>
                                                            <div
                                                                :class="['form-control-wrap', { 'is-error' : date.errors.to }]">
                                                                <input type="text" Placeholder="Date To"
                                                                       :value="date.to"
                                                                       @focus="date.errors.to = false"
                                                                       @blur="date.to = $event.target.value;isEdit = true"
                                                                       class="form-control js-datepicker-single">
                                                                <div class="form-control-icon">
                                                                    <svg width="1em" height="1em"
                                                                         class="icon icon-calendar ">
                                                                        <use
                                                                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="form-control-group form-control-group_seasons2">
                                                        <div
                                                            :class="['select-wrapper', {'is-active': date.select}, { 'is-error' : date.errors.season }]"
                                                            @click="date.errors.season = false;years = years.map((year, yearIndex) => ({...year, yearSelect: false, dates: yearIndex === index ? year.dates.map((dateItem, dateIndex) => ({...dateItem, select: dateIndex === i ? !dateItem.select : false})) : year.dates.map(dateItem => ({...dateItem, select: false}))}))">
                                                            <div class="select-trigger">
                                                                <span class="select-trigger__name">{{
                                                                        date.season ? date.season.name : ''
                                                                    }}</span>
                                                                <span class="select-trigger__icon">
                                              <svg width="1em" height="1em" class="icon icon-chevron ">
                                                  <use
                                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                              </svg>
                                          </span>
                                                            </div>
                                                            <div class="select-body">
                                                                <div class="select-inner js-scrollbar">
                                                                    <div v-for="(item) in seasonsSelect" :key="item.id"
                                                                         :class="['select-option', { 'is-selected' : date.season && item.id === date.season.id}]"
                                                                         @click="date.season = item;isEdit = true"><span
                                                                        class="select-option__name">{{
                                                                            item.name
                                                                        }}</span></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button type="button" class="btn btn--remove" @click="$emit('deleteModalHandler', {
                                    entity: 'Season',
                                    name: 'this',
                                    handler: () => {
                                        removeYearSeason(index, i)
                                    },
                                    id: null
                                })">
                                                        <svg width="1em" height="1em" class="icon icon-close ">
                                                            <use
                                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                                        </svg>
                                                    </button>
                                                </div>
                                                <div class="edit-seasons__btns">
                                                    <button type="button" class="btn btn--rounded2 btn--green"
                                                            @click="addYearSeason(index) ">
                                                        <span>Add Season</span></button>
                                                </div>
                                            </div>
                                        </div>


                                        <div class="edit-seasons-btns">
                                            <div>
                                                <a class="btn btn--rounded2 btn--green btn_add-year"
                                                   @click="addYear"><span>Add Year</span></a>
                                                <a class="btn btn--rounded2 btn--green btn_same-seasons"
                                                   @click="addYearWithSeasons"><span>Add Year with the same seasons</span></a>
                                            </div>
                                            <button type="button" class="btn btn--green btn_update-seasons"
                                                    @click="updatePopup = true"><span>Update</span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="modal-wrapper" v-if="updatePopup">
                            <div class="modal-backdrop"></div>
                            <div class="modal-inner">
                                <div class="edit-popup edit-popup--history">
                                    <div class="edit-popup__header">
                                        <div class="edit-popup__title">
                                            Update History
                                        </div>
                                        <div class="edit-popup__close" @click="updatePopup = false">
                                            <svg width="1em" height="1em" class="icon icon-close ">
                                                <use
                                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                            </svg>
                                        </div>
                                    </div>
                                    <form action="javascript:void(0)" class="edit-popup__inner">
                                        <div class="form-control-group"><span
                                            class="form-control-label">Hi {{ user ? user.data.firstName : '' }}, <span> what have you updated?</span> </span>
                                            <div class="form-control-wrap">
                                                <textarea class="form-control" v-model="descriptionUpdate">Rates, Hotel Description</textarea>
                                            </div>
                                          <div class="edit-popup__error-text">
                                            <span v-if="descriptionUpdate.length < 6">Minimum 6 symbols are required</span>
                                          </div>
                                        </div>
                                        <div class="options-additional__btns">
                                            <button type="button" class="btn btn--silver" @click="updatePopup = false">
                                                <span>Cancel</span>
                                            </button>
                                            <button type="button" class="btn btn--green edit-popup__submit"
                                                    :disabled="descriptionUpdate.length < 6"
                                                    @click="updatePopup === 'seasons' ? updateSeasons() : updateYearsHandler()">
                                                <span>Update</span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="modal-wrapper" v-if="copy">
                            <div class="modal-backdrop"></div>
                            <div class="modal-inner">
                                <div class="edit-popup edit-popup--copy-season">
                                    <div class="edit-popup__header">
                                        <div class="edit-popup__title" :style="{marginBottom: '0px'}">
                                            <div class="edit-popup__title__icon">
                                                <svg width="1em" height="1em" class="icon icon-copy ">
                                                    <use
                                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                                                </svg>
                                            </div>
                                            <span>Copy seasons from other year </span>
                                        </div>
                                        <div class="edit-popup__close" @click="copy = false">
                                            <svg width="1em" height="1em" class="icon icon-close ">
                                                <use
                                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                            </svg>
                                        </div>
                                    </div>
                                    <form action="javascript:void(0)" class="edit-popup__inner">
                                        <div class="edit-popup__side-wrap">
                                            <div class="edit-popup__side">
                                                <div class="form-control-group"><span
                                                    class="form-control-label form-control-label-bold">Season will be copied from the season:</span>
                                                    <div :class="['select-wrapper', {'is-active': copySelect}]"
                                                         @click="copySelect = !copySelect">
                                                        <div class="select-trigger">
                                                            <span class="select-trigger__name">{{ copyYear }}</span>
                                                            <span class="select-trigger__icon">
                                            <svg width="1em" height="1em" class="icon icon-chevron ">
                                            <use
                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                            </svg>
                                        </span>
                                                        </div>
                                                        <div class="select-body">
                                                            <div class="select-inner js-scrollbar">
                                                                <div
                                                                    v-for="(year, index) in data.years.filter(year => !(year === copy)).filter(y => years.map(yd => yd.year).includes(y))"
                                                                    :key="index"
                                                                    :class="['select-option', { 'is-selected' : year === copyYear }]"
                                                                    @click="copyYear = year"><span
                                                                    class="select-option__name">{{ year }}</span></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <button type="button" :disabled="!copyYear"
                                                    class="btn btn--green edit-popup__submit"
                                                    @click="copySeasons(copy, copyYear)">
                                                <svg width="1em" height="1em" class="icon icon-copy ">
                                                    <use
                                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                                                </svg>
                                                <span>Copy</span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </main>
    </div>
</template>

<script>

import Lightpick from 'lightpick'

import {
    getHotelsSeasons,
    updateHotelsSeasons,
    getHotelsPeriods,
    updateHotelsPeriods,
    getHotelAdvanced
} from '@/utilites/api'

import {
    date
} from '@/utilites/functions'

import {format, parse, setYear} from 'date-fns'
import HotelsSideMenu from '@/components/HotelsSideMenu/HotelsSideMenu.vue'

export default {
    components: {HotelsSideMenu, Lightpick},
    data() {
        return {
            isEdit: false,
            isLoad: false,
            updatePopup: false,
            descriptionUpdate: '',
            seasons: [],
            seasonsSelect: [],
            years: [],
            copy: false,
            copySelect: false,
            copyYear: null,
            data: {
                years: [
                    2021,
                    2022,
                    2023,
                    2024,
                    2025,
                    2026,
                    2027,
                    2028,
                    2029,
                    2030
                ]
            },
            hotelName: ''
        }
    },
    props: ['user'],
    beforeRouteLeave(to, from, next) {
        if (this.isEdit) {
            this.$emit('notLeaveHandler')
        }
        next()
    },
    beforeCreate() {
        document.title = 'Hotels';
    },
    created() {
        getHotelAdvanced(this.$route.params.id)
            .then(res => {
                this.hotelName = res.names.EN
            })
    },
    mounted() {
        this.updateDatePickers()
        this.updateData()
        window.addEventListener('click', event => {
            if (!event.target.closest('.select-wrapper')) {
                this.years = this.years.map(item => ({
                    ...item,
                    yearSelect: false,
                    dates: item.dates.map(date => ({...date, select: false}))
                }))
            }
        })

    },
    methods: {
        changeYear(yearObj) {
            yearObj.dates.forEach(date => {
                date.from = format(setYear(new Date(format(parse(date.from, 'dd MMM yyyy', new Date()), 'yyyy, MM, dd')), yearObj.year), 'dd MMM yyyy')
                date.to = format(setYear(new Date(format(parse(date.to, 'dd MMM yyyy', new Date()), 'yyyy, MM, dd')), yearObj.year), 'dd MMM yyyy')
            })
            this.updateDatePickers()
        },
        addSeason() {
            this.seasons = this.seasons.concat({name: '', hotelId: +this.$route.params.id})
            this.isEdit = true
        },
        removeSeason(index) {
            this.seasons = this.seasons.filter((_, i) => !(i === index))
            this.isEdit = true
        },
        checkErrorsSeasons() {
            let error = false
            this.seasons = this.seasons.map(item => {
                if (!item.name) {
                    error = true
                    return ({
                        ...item,
                        error: true
                    })
                }
                return item
            })
            return error
        },
        checkErrorsYears() {
            let error = false
            this.years = this.years.map(item => {
                if (!item.year || item.dates.find(date => !date.season || !date.from || !date.to)) {
                    error = true
                    return ({
                        ...item,
                        error: !item.year,
                        dates: item.dates.map(date => {
                            error = true
                            return {
                                ...date,
                                errors: {
                                    season: !date.season,
                                    from: !date.from,
                                    to: !date.to
                                }
                            }
                        })
                    })
                }
                return item
            })
            return error
        },
        updateSeasons() {
            if (!this.checkErrorsSeasons()) {
                updateHotelsSeasons({
                    seasons: this.seasons.map(item => {
                        let data = {name: item.name, hotelId: +this.$route.params.id}
                        if (item.id) {
                            data.id = item.id
                        }
                        return data
                    }),
                    // history: {
                    //     hotelId: +this.$route.params.id,
                    //     userId: this.user.data.id,
                    //     description: this.descriptionUpdate
                    // }
                }, this.$route.params.id)
                    .then(res => {
                        this.updateData(false)
                        this.$emit('confirmed')
                        this.updatePopup = false
                        this.descriptionUpdate = ''
                        this.isEdit = false
                    })
            } else {
                this.updatePopup = false
                this.descriptionUpdate = ''
            }
        },
        addYear() {
            if (this.data.years.filter(y => !this.years.map(yd => yd.year).includes(y)).length || this.years.length < 10) {
                this.years = this.years.concat({
                    hotelId: +this.$route.params.id,
                    year: null,
                    yearSelect: false,
                    dates: []
                })
                this.updateDatePickers()
            }
            this.isEdit = true
        },
        addYearWithSeasons() {
            if (this.data.years.filter(y => !this.years.map(yd => yd.year).includes(y)).length || this.years.length < 10) {
                this.years = this.years.concat({
                    ...this.years[this.years.length - 1],
                    year: null,
                    dates: this.years[this.years.length - 1].dates.map(item => {
                        delete item.id
                        return item
                    })
                })
                this.updateDatePickers()
            }
            this.isEdit = true
        },
        addYearSeason(year) {
            this.years = this.years.map((y, yI) => ({
                ...y, dates: yI === year ? y.dates.concat({
                    from: '',
                    to: '',
                    select: false,
                    season: null,
                    errors: {}
                }) : y.dates
            }))
            this.updateDatePickers()
            this.isEdit = true
        },
        copySeasons(to, from) {
            let fromData = this.years.find(item => item.year === from)

            this.years = this.years.map(item => {
                if (item.year === to) {
                    return {
                        ...item,
                        dates: fromData.dates.map(dateItem => {
                            delete dateItem.id
                            return {
                                ...dateItem,
                                from: format(setYear(new Date(format(parse(dateItem.from, 'dd MMM yyyy', new Date()), 'yyyy, MM, dd')), to), 'dd MMM yyyy'),
                                to: format(setYear(new Date(format(parse(dateItem.to, 'dd MMM yyyy', new Date()), 'yyyy, MM, dd')), to), 'dd MMM yyyy')
                            }
                        })
                    }
                }
                return item
            })
            this.copy = false
            this.copySelect = false
            this.copyYear = null
            this.updateDatePickers()
        },
        removeYearSeason(year, date) {
            this.years = this.years.map((y, yI) => ({
                ...y,
                dates: yI === year ? y.dates.filter((d, dI) => !(dI === date)) : y.dates
            }))
            this.updateDatePickers()
            this.isEdit = true
        },
        removeYear(index) {
            this.years = this.years.filter((_, i) => !(i === index))
            this.isEdit = true
        },
        updateYearsHandler() {
            if (!this.checkErrorsYears()) {
                updateHotelsPeriods({
                    periods: this.years.map(year => year.dates.map(dateItem => ({
                        "id": dateItem.id,
                        "hotelId": +this.$route.params.id,
                        "year": year.year,
                        "seasonId": dateItem.season.id,
                        "dateFrom": date(dateItem.from, 'start'),
                        "dateTo": date(dateItem.to, 'start')
                    }))).flat().map(item => {
                        if (item.id === undefined) {
                            delete item.id
                        }
                        return item
                    }),
                    history: {
                        hotelId: +this.$route.params.id,
                        userId: this.user.data.id,
                        description: this.descriptionUpdate
                    }
                }, this.$route.params.id)
                    .then(res => {
                        this.isEdit = false
                        this.updateData()
                        this.$emit('confirmed')
                        this.updatePopup = false
                        this.descriptionUpdate = ''
                    })
                    .catch(e => {
                        this.updatePopup = false
                        this.descriptionUpdate = ''
                        this.$emit('errored', {text: 'Crosses of periods are detected'})
                    })
            } else {
                this.isEdit = false
                this.updatePopup = false
                this.descriptionUpdate = ''
            }
        },
        updateDatePickers() {
            document.querySelectorAll('.lightpick').forEach(elem => {
                elem.remove()
            })
            setTimeout(() => {
                document.querySelectorAll('.js-datepicker-single').forEach(item => {
                    const datePicker = new Lightpick({
                        field: item,
                        singleDate: true,
                        lang: 'en',
                        format: 'DD MMM yyyy',
                        onClose: function () {
                            item.blur()
                        },
                        onSelect: function () {
                            item.focus()
                            item.blur()
                        }
                    });
                    item.addEventListener('blur', () => {
                        datePicker.hide()
                    })
                });
            }, 1000)
        },
        updateData(flag = true) {
            const id = this.$route.params.id
            Promise.all([getHotelsSeasons(id), getHotelsPeriods(id)])
                .then(res => {
                    this.seasons = res[0]
                    this.seasonsSelect = res[0]
                    if (flag) {
                        this.years = []
                        let years = []
                        this.data.years.forEach(item => {
                            years = res[1].filter(y => y.year === item)
                            this.years = this.years.concat({
                                hotelId: +this.$route.params.id,
                                year: item,
                                yearSelect: false,
                                dates: years.map(dateItem => ({
                                    errors: {},
                                    id: dateItem.id,
                                    from: date(dateItem.dateFrom, 'fromStart'),
                                    to: date(dateItem.dateTo, 'fromStart'),
                                    select: false,
                                    season: this.seasons.find(season => season.id === dateItem.seasonId)
                                }))
                            }).filter(item => item.dates.length)
                        })
                    }
                    this.isLoad = true
                })
        },
        waitSaveTiming() {
            const saveFun = () => {
                this.updatePopup = true;
            }
            const waitFun = () => {
                this.waitSaveTiming();
            }
            setTimeout(() => {
                this.$emit('waitSaveHandler', [saveFun, waitFun]);
            }, 10 * 60 * 1000)
        },
    },
    watch: {
        isEdit(val) {
            if (val) this.waitSaveTiming();
        },
    },
}
</script>
